export const PRODUCT = 'HOME APPLIANCE DIAGNOSTIC PRO™'

export const PRODUCT_TAGLINE =
  'THE COMPLETE VISUAL FAULT-FINDING SYSTEM FOR HOME APPLIANCE TECHNICIANS'

/** Anchor id of the $27 purchase section */
export const OFFER_ANCHOR = '#offer'

export const CHECKOUT_URL =
  'https://home-appliance-diagnostic-pro.impultienda.ar/checkout'

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/mAVorNzwkCVp7vBk1St92h/Diseno_sin_titulo-12.webp'

export const SUPPORT_EMAIL = 'kitonline27@gmail.com'

export const PIXEL_ID = '1128992796473413'
